export const currency = {
  MX: {
    // 是否需要保留两位小数处理
    isNeedFixed: true,
    rate: 100,
    symbol: 'MX$',
    maxVal: 9999.99,
    reg: /^\d*(\.?\d{0,2})/g,
  },
  CR: {
    // 是否需要保留两位小数处理
    isNeedFixed: false,
    rate: 100,
    symbol: '₡',
    maxVal: 100000,
    reg: /^\d*/g,
  },
  CO: {
    // 是否需要保留两位小数处理
    isNeedFixed: false,
    rate: 100,
    symbol: '$',
    maxVal: 500000,
    reg: /^\d*/g,
  },
  BR: {
    // 是否需要保留两位小数处理
    isNeedFixed: true,
    rate: 100,
    symbol: 'R$',
    maxVal: 9999.99,
    reg: /^\d*(\.?\d{0,2})/g,
  },
  PE: {
    // 是否需要保留两位小数处理
    isNeedFixed: true,
    rate: 100,
    symbol: 'S/',
    maxVal: 9999.99,
    reg: /^\d*(\.?\d{0,2})/g,
  },
  default: {
    // 是否需要保留两位小数处理
    isNeedFixed: true,
    rate: 100,
    symbol: 'MX$',
    maxVal: 9999.99,
    reg: /^\d*(\.?\d{0,2})/g,
  },
}
